import {createContext, useContext, useEffect, useState} from "react";

const ThemeContext = createContext<any>({})

export const useTheme = () => {
    return useContext(ThemeContext);
}

export const ThemeProvider = ({ children }: any) => {
    const [themeValue, setThemeValue] = useState("");

    const setTheme = (value: string) => {
        setThemeValue(value);
    };
    const getTheme = () =>  themeValue;

    useEffect(() => {
        if (themeValue) {
            document.documentElement.setAttribute(
                "data-bs-theme",
                themeValue
            );
            localStorage.setItem("theme", themeValue)
        }
    }, [themeValue])

    useEffect(() => {
        if (localStorage.getItem("theme") === "dark") {
            setThemeValue("dark")
        } else if (localStorage.getItem("theme") === "light") {
            setThemeValue("light")
        } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            setThemeValue("dark")
        } else {
            setThemeValue("light")
        }
    }, [])

    return (
        <ThemeContext.Provider value={{setTheme, getTheme}}>
            { children }
        </ThemeContext.Provider>
    )
}